var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 49,
    viewBox: "0 0 52 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg 2",
    clipPath: "url(#clip0_1699_12153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.6188 22.6003C45.4466 22.6003 48.3283 20.9907 50.453 18.1884L47.6133 16.0014C46.9118 16.9346 46.0052 17.6905 44.965 18.2097C43.9248 18.7289 42.7793 18.9971 41.6188 18.9932C37.4646 18.9932 34.4544 15.5771 34.4544 11.3854C34.4544 7.19373 37.4155 3.58525 41.7373 3.58525C43.6584 3.58525 45.0162 4.04304 46.2006 4.7837V8.46946H49.7742V3.09537L49.0895 2.55151C47.125 0.991467 44.1249 0.16333 41.6174 0.16333C35.4872 0.16333 30.5009 5.19632 30.5009 11.384C30.5009 17.5659 35.4857 22.6003 41.6188 22.6003ZM49.0332 44.7325L48.906 39.5669V26.9611H41.4527V30.5696H45.1418V39.1222C45.1418 42.8065 42.354 45.4148 39.5417 45.4148C36.7294 45.4148 35.2618 43.4466 35.2618 39.7637V26.9597H28.2996V30.5682H31.4976V40.3892C31.4976 45.3871 34.2738 48.8309 39.2254 48.8309C42.0709 48.8309 44.2376 47.2373 45.5304 44.7806H45.5882L46.098 48.2157H51.8253V44.7369H49.0375V44.7296L49.0332 44.7325ZM29.6776 0.692589H23.4665L18.0643 16.5263H17.9805L12.6072 0.692589H5.98871V4.30254H9.71105L16.1172 22.3495H19.5203V22.3451L26.2008 4.30401H29.6747V0.694057L29.6776 0.692589ZM0.17627 48.2623H3.85671V44.5488H0.177714V48.2623H0.17627ZM14.3896 31.1455H14.3492L14.118 26.9611H7.54871V30.2504H11.0443V44.734H7.54871V48.2142H23.7843V44.8025H14.7449V36.0619C15.1537 32.8981 17.5038 30.1964 20.7105 30.1964H20.7683L20.7033 33.4302H24.2768V26.9013H21.4515C18.2159 26.8926 15.8153 28.6597 14.3882 31.147L14.3896 31.1455Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1699_12153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.ab407affe98ce1079fa35ba2eaf1d647.svg";
export { ForwardRef as ReactComponent };